/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TomoQuestionnaire } from '../../models/tomo-questionnaire';

export interface PutTomoquestionnaireId$Plain$Params {

/**
 * questionnaire ID
 */
  id: string;
  'api-version'?: string;
  
    /**
     * questionnaire object
     */
    body?: TomoQuestionnaire
}

export function putTomoquestionnaireId$Plain(http: HttpClient, rootUrl: string, params: PutTomoquestionnaireId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
  const rb = new RequestBuilder(rootUrl, putTomoquestionnaireId$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TomoQuestionnaire>;
    })
  );
}

putTomoquestionnaireId$Plain.PATH = '/tomoQuestionnaire/{id}';
